<template>
  <div
    v-if="isMobile || isDesktop"
    class="main-product__sidebar-header"
  >
    <div class="main-product__sidebar-header-wrapper">
      <h1
        id="template-title"
        class="
          main-product__title
          text-heading-xl
        "
        v-text="product.title || liquid.title"
      />

      <!-- main-product__sidebar-header-badge -->
      <div
        v-if="badge"
        class="main-product__badges "
      >
        <product-badge
          :text="badge"
          :badge-class="productBadgeClass"
          text-class="text-heading-s text-heading-m-desktop"
        />
      </div>
    </div>

    <p
      class="main-product__description text-body-l-regular rte"
      v-html="product.briefDescription || liquid.briefDescription"
    />

    <p
      v-if="variantCompatible"
      class="main-product__compatibility text-body-l-regular"
    >
      <span
        class="main-product__compatibility-label text-body-l-regular"
        v-text="$string('product.sidebar.works_with')"
      />
      <span
        v-for="(compatible, index) of variantCompatible"
        :key="compatible"
      >
        <span
          class="main-product__compatibility-item text-heading-s"
          v-text="compatible"
        />
        <span
          v-if="(variantCompatible.length - 1) > index"
          class="main-product__compatibility-separator"
        >|</span>
      </span>
    </p>
    <p
    v-if="variantCompatible == '' && variantSingleCompatible"
      class="main-product__compatibility text-body-l-regular"
    >
      <span 
        class="main-product__compatibility-label text-body-l-regular"
        v-text="$string('product.sidebar.works_with')"
      />
    
        <span
          class="main-product__compatibility-item text-heading-s"
          v-text="variantSingleCompatible"
        />
       
    </p>
    <div class="main-product__meta">
      <p
        v-if="sku"
        class="main-product__sku text-body-l-regular"
        v-text="sku"
      />

      <product-rating
        :sku="variantSkus"
        @click="handleClick"
      />
    </div>
    <product-prices v-if="liquid.type != 'sawmill'"
      class="main-product__prices-container"
      class-price="text-heading-l"
      class-compare-at-price="text-heading-l"
      :product="product"
      :available="variant.available"
      :compare-at-price="variant.compareAtPrice?.amount"
      :price="variant.price?.amount || liquid.selectedOrFirstAvailableVariant?.price?.amount"
      :varies="variant.price?.varies || liquid.selectedOrFirstAvailableVariant?.price?.varies"
      :affirm=true
      sawmill="main-product__prices-container"
    />
    <div v-if="currentCountryName === 'United States' && liquid.type === 'sawmill'" class="main-product__breadpay  main-product__description">
      <div  :data-price="variant.price?.amount || liquid.selectedOrFirstAvailableVariant?.price?.amount" :data-sku="variant.sku ||  liquid.selectedOrFirstAvailableVariant?.sku" :id="`bread-${variant.id|| liquid.selectedOrFirstAvailableVariant?.id}`" class="bread-as-low-as-container main-product__breadpaybtn"></div>
      <div  :data-price="variant.price?.amount || liquid.selectedOrFirstAvailableVariant?.price?.amount" :data-sku="variant.sku ||  liquid.selectedOrFirstAvailableVariant?.sku" :id="`breadpay-${variant.id|| liquid.selectedOrFirstAvailableVariant?.id}`">
     </div>
    
    </div>

    <p
      v-if="product.specialMessaging"
      class="main-product__promo-message text-body-m-regular  mt-l mt-xl-desktop"
      v-text="product.specialMessaging"
    />

    <div v-for="(giftuid, indexs) in giftui" :key="indexs">
      <div class="main-product__giftui text-body-m-regular mt-l mt-xl-desktop">
        <div class="main-product__giftui-title" :style="{ backgroundColor: giftuid.color }">
          <span><img v-if="giftuid.icon" :src="giftuid.icon.src" alt="giftui"></span>
          &nbsp;
          <span class="main-product__giftui-title-text">{{ giftuid.title }}</span>
          &nbsp;
          <span><img v-if="giftuid.icon" :src="giftuid.icon.src" alt="giftui"></span>
        </div>
        <div class="main-product__giftui-content" v-html="giftuid.text"></div>
      </div>
    </div>

  </div>
</template>

<script>
import ProductPrices from '~global/product-prices/product-prices'
import ProductBadge from '~async/product-badge/product-badge.vue'
import ProductRating from '~async/product-rating/product-rating'

export default {
  name: 'MainProductSidebarHeader',
  components: {
    ProductPrices,
    ProductBadge,
    ProductRating,
  },
  props: {
    liquid: {
      type: Object,
      default: () => ({
        description: '',
        price: 0,
        title: '',
      }),
    },
    product: {
      type: [Boolean, Object],
      default: false,
    },
    variant: {
      type: [Boolean, Object],
      default: false,
    },
    isMobile: {
      type: Boolean,
      default: false,
    },
    isDesktop: {
      type: Boolean,
      default: false,
    },
    giftui: {
      type: [Array],
      default: () => {
        return []
      },
    },
  },

  emits: {
    'scroll-to-view': () => true,
  },

  data() {
    return {
      activeAccordion: null,
      currentCountryName: cnvs.store.countryName,
    }
  },

  computed: {

    /**
     * Computed SKU.
     */
    sku() {
      if (!this.variant.sku) {
        return false
      }
      return `Sku: ${this.variant.sku}`
    },

    /**
     * Parse compatibility string into an array.
     */
    compatibilityList() {
      let compatibilityList = []
      if (this.liquid.compatibility) {
        compatibilityList = this.liquid.compatibility.split('|').map((item) => item.trim())
      }

      return compatibilityList
    },

    /**
     * Generate badge class
     */
    productBadgeClass() {
      let badgeClass = ''
      if (!this.badge) {
        return badgeClass
      }

      const badge = this.badge.replace(' ', '-')
      badgeClass = `product-badge--${badge}`
      return badgeClass
    },

    /**
     * Generate badge text
     */
    badge() {
      let badge = false
      const product = this.product || this.liquid
      const sale = product.price.amount < product.compareAtPrice.amount

      //if (sale) {
      //  badge = this.$string('collection.badge.sale').toLowerCase()
      //  return badge
      //}

      const badgeTag = product.tags ? product.tags.find((tag) => tag.includes('badge:')) : false

      if (badgeTag) {
        badge = badgeTag.replace('badge:', '').toLowerCase()
      }
      return badge
    },

    variantSkus() {
      const product = this.product || this.liquid
      if (!product) {
        return ''
      }

      const sku = product.variants.map((variant) => variant.sku)
      return sku.join(';')
    },
     variantCompatible() {
        const product = this.product || this.liquid
        if (!product) {
          return ''
        }

        const compatibility =  this.variant.compatibleWith
        //return compatibility
        if(typeof compatibility == 'string'){
        if(compatibility.includes(','))
        {
          return compatibility.split(',')
        }
        else if(compatibility.includes('|')){
        
          return compatibility.split('|')
        }else{
          return ''
        }
      }
     
    },
    variantSingleCompatible() {
        const variant = this.product || this.liquid
        if (!variant) {
          return ''
        }
        const singlecomp =  this.variant.compatibleWith
        if(typeof singlecomp == 'string'){
        
        if(!singlecomp.includes(',') || !singlecomp.includes('|'))
        {
          return this.variant.compatibleWith
        }
        }
      }
  },

  mounted() {
  },

  methods: {  
     

    handleClick() {
      this.$emit('scroll-to-view')
    },

    /**
     * Generate badge text label by checking if it exists as a setting
     * @param {String} badge - badge name.
     */
    productBadgeText(badge) {
      if (badge.includes('_') && this.labels[`${badge}`]) {
        return this.labels[`${badge}`]
      }
      return badge
    },
  },
}
</script>
